import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { RoteiroService } from '../roteiro.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { AgendaRoteiroPontoFisico } from '../../comum/modelos/agenda-roteiro-ponto-fisico';
import { ConfirmationService, SelectItem } from 'primeng/primeng';
import { SetorPontoFisico } from '../../comum/modelos/setor-ponto-fisico';
import { ProcessoSetor } from '../../comum/modelos/processo-setor';
import { Setor } from '../../comum/modelos/setor';
import { Processo } from '../../comum/modelos/processo';
import { RotinaProcesso } from '../../comum/modelos/rotina-processo';
import { RotinaCliente } from '../../comum/modelos/rotina-cliente';
import { SetorService } from '../../setor/setor.service';
import { ProcessoService } from '../../processo/processo.service';
import { RotinaService } from '../../rotina/rotina.service';
import { AgendaRoteiroSetor } from '../../comum/modelos/agenda-roteiro-setor';
import { AgendaRoteiroProcesso } from '../../comum/modelos/agenda-roteiro-processo';
import { AgendaRoteiroRotina } from '../../comum/modelos/agenda-roteiro-rotina';
import { PontoFisico } from '../../comum/modelos/ponto-fisico';
import { Data } from '../../comum/data/data';


@Component({
    selector: 'app-cadastro-roteiro-interno',
    templateUrl: './cadastro-roteiro-interno.component.html',
    styleUrls: ['./cadastro-roteiro-interno.component.css']
})
export class CadastroRoteiroInternoComponent implements OnInit {
    @Output() agendaRoteiroPontoFisicoEvent: EventEmitter<AgendaRoteiroPontoFisico>;

    agendaRoteiroPontoFisico: AgendaRoteiroPontoFisico;
    setoresPontoFisico: SetorPontoFisico[];
    setores: Setor[];
    processosSetor: ProcessoSetor[];
    processos: Processo[];
    rotinasProcesso: RotinaProcesso[];
    rotinasCliente: RotinaCliente[];
    agendasRoteiroSetor: AgendaRoteiroSetor[];
    agendasRoteiroProcesso: AgendaRoteiroProcesso[];
    agendasRoteiroRotina: AgendaRoteiroRotina[];
    setoresSelectItem: SelectItem[];
    processosSelectItem: SelectItem[];
    rotinasSelectItem: SelectItem[];
    idsSetoresSelecionados: number[] = [];
    idsProcessosSelecionados: number[] = [];
    idsRotinasSelecionados: number[] = [];
    selecione = 'Selecione';

    statusCode: number;

    public loading = false;

    constructor (
        private _roteiroService: RoteiroService,
        private _setorService: SetorService,
        private _processoService: ProcessoService,
        private _rotinaService: RotinaService,
        private confirmationService: ConfirmationService,
        private data: Data) {
        this.setoresPontoFisico = new Array<SetorPontoFisico>();
        this.setores = new Array<Setor>();
        this.processosSetor = new Array<ProcessoSetor>();
        this.processos = new Array<Processo>();
        this.rotinasProcesso = new Array<RotinaProcesso>();
        this.rotinasCliente = new Array<RotinaCliente>();
        this.agendasRoteiroSetor = new Array<AgendaRoteiroSetor>();
        this.agendasRoteiroProcesso = new Array<AgendaRoteiroProcesso>();
        this.agendasRoteiroRotina = new Array<AgendaRoteiroRotina>();
        this.setoresSelectItem = new Array<SelectItem>();
        this.processosSelectItem = new Array<SelectItem>();
        this.rotinasSelectItem = new Array<SelectItem>();
        this.agendaRoteiroPontoFisico = new AgendaRoteiroPontoFisico();
        this.agendaRoteiroPontoFisicoEvent = new EventEmitter<AgendaRoteiroPontoFisico>();
    }

    ngOnInit() {
        this.loading = true;
        const self = this;
        this.agendaRoteiroPontoFisico = this.data.storage.agendaRoteiroPontoFisico;
        forkJoin(
            this._roteiroService.obterAgendasRoteiroSetorHttp(this.agendaRoteiroPontoFisico.idAgendaRoteiroPontoFisico),
            this._roteiroService.obterAgendasRoteiroProcessoHttp(this.agendaRoteiroPontoFisico.idAgendaRoteiroPontoFisico),
            this._roteiroService.obterAgendasRoteiroRotinaHttp(this.agendaRoteiroPontoFisico.idAgendaRoteiroPontoFisico))
            .subscribe(([agendasSetor, agendasProcesso, agendasRotina]) => {
                self.agendasRoteiroSetor = agendasSetor;
                self.agendasRoteiroProcesso = agendasProcesso;
                self.agendasRoteiroRotina = agendasRotina;

                self.loading = true;
                self.setoresSelectItem = [];
                const pontosFisicos = new Array<PontoFisico>();
                const pontoFisico = new PontoFisico();
                pontoFisico.idPontoFisico = this.agendaRoteiroPontoFisico.idPontoFisico;
                pontosFisicos.push(pontoFisico);
                self._setorService.obterSetoresFromPontosFisicosHttp(pontosFisicos)
                    .subscribe((setores) => {
                        self.setores = setores;
                        self.setores.forEach(setor => {
                            self.setoresSelectItem.push({
                                label: setor.nomeSetor, value: setor.idSetor
                            });
                        });

                        self._setorService.obterSetoresPontosFisicosHttp(pontosFisicos)
                            .subscribe(setoresPontoFisico => {
                                const setoresPontoFisicoSelecionados = new Array<SetorPontoFisico>();
                                for (const setorPontoFisico of setoresPontoFisico) {
                                    for (const agendaRoteiroSetor of agendasSetor) {
                                        if (setorPontoFisico.idSetorPontoFisico === agendaRoteiroSetor.idSetorPontoFisico) {
                                            setoresPontoFisicoSelecionados.push(setorPontoFisico);
                                            self.idsSetoresSelecionados.push(setorPontoFisico.setor.idSetor);
                                            break;
                                        }
                                    }
                                    self.setoresPontoFisico.push(setorPontoFisico);
                                }

                                self.processosSelectItem = [];
                                if (setoresPontoFisicoSelecionados.length > 0) {
                                    self._processoService.obterProcessosFromSetoresPontoFisicoHttp(setoresPontoFisicoSelecionados)
                                        .subscribe((processos) => {
                                            self.processos = processos;
                                            self.processos.forEach(processo => {
                                                self.processosSelectItem.push({
                                                    label: processo.nomeProcesso, value: processo.idProcesso
                                                });
                                            });

                                            self._processoService.obterProcessosSetoresHttp(setoresPontoFisicoSelecionados)
                                                .subscribe((processosSetor: ProcessoSetor[]) => {
                                                    const processosSetoresSelecionados = new Array<ProcessoSetor>();
                                                    for (const processoSetor of processosSetor) {
                                                        for (const agendaRoteiroProcesso of agendasProcesso) {
                                                            if (processoSetor.idProcessoSetor === agendaRoteiroProcesso.idProcessoSetor) {
                                                                processosSetoresSelecionados.push(processoSetor);
                                                                self.idsProcessosSelecionados.push(processoSetor.processo.idProcesso);
                                                                break;
                                                            }
                                                        }
                                                        self.processosSetor.push(processoSetor);
                                                    }

                                                    self._rotinaService.obterRotinasClienteFromProcessosSetorHttp
                                                        (processosSetoresSelecionados).subscribe((rotinasCliente) => {
                                                            self.rotinasCliente = rotinasCliente;
                                                            self.rotinasCliente.forEach(rotina => {
                                                                self.rotinasSelectItem.push({
                                                                    label: rotina.descricaoRotina,
                                                                    value: rotina.idRotinaCliente
                                                                });
                                                            });

                                                            self._rotinaService.obterRotinasProcessosHttp(processosSetoresSelecionados)
                                                                .subscribe((rotinasProcesso: RotinaProcesso[]) => {
                                                                    const rotinasProcessoSelecionadas = new Array<RotinaProcesso>();
                                                                    for (const rotinaProcesso of rotinasProcesso) {
                                                                        for (const agendaRoteiroRotina of agendasRotina) {
                                                                            if (rotinaProcesso.idRotinaProcesso
                                                                                === agendaRoteiroRotina.idRotinaProcesso) {
                                                                                rotinasProcessoSelecionadas.push(rotinaProcesso);
                                                                                self.idsRotinasSelecionados.push(
                                                                                    rotinaProcesso.rotinaCliente.idRotinaCliente);
                                                                                break;
                                                                            }
                                                                        }
                                                                        self.rotinasProcesso.push(rotinaProcesso);
                                                                        self.loading = false;
                                                                    }
                                                                });
                                                        });
                                                });
                                        });
                                } else {
                                    self.loading = false;
                                }
                            });
                    });
            });
    }

    selecionarProcessos(idsSetor: number[]): void {
        this.loading = true;
        this.idsSetoresSelecionados = idsSetor;
        this.processosSelectItem = [];
        this.idsProcessosSelecionados = [];
        this.idsRotinasSelecionados = [];
        this.rotinasSelectItem = [];
        const listaSetor = new Array<SetorPontoFisico>();
        this.setoresPontoFisico.forEach(setorPontoFisico => {
            if (idsSetor.find(idSetor => idSetor === setorPontoFisico.setor.idSetor)) {
                listaSetor.push(setorPontoFisico);
            }
        });
        if (idsSetor.length > 0) {
            this._processoService.obterProcessosFromSetoresPontoFisicoHttp(listaSetor)
                .subscribe((processos) => {
                    this.processos = processos;
                    this.processos.forEach(processo => {
                        this.processosSelectItem.push({
                            label: processo.nomeProcesso, value: processo.idProcesso
                        });
                    });
                    this._processoService.obterProcessosSetoresHttp(listaSetor)
                        .subscribe((processosSetor: ProcessoSetor[]) => {
                            processosSetor.forEach(processoSetor => {
                                this.processosSetor.push(processoSetor);
                            });
                            this.loading = false;
                        });
                });
        } else {
            this.loading = false;
        }
    }

    selecionarRotinas(idsProcesso: number[]): void {
        this.loading = true;
        this.idsProcessosSelecionados = idsProcesso;
        this.idsRotinasSelecionados = [];
        this.rotinasSelectItem = [];
        const listaProcessos = new Array<ProcessoSetor>();
        if (idsProcesso.length > 0) {
            this.processosSetor.forEach(processoSetor => {
                if (idsProcesso.find(idProcesso => idProcesso === processoSetor.processo.idProcesso)) {
                    listaProcessos.push(processoSetor);
                }
            });

            this._rotinaService.obterRotinasProcessosHttp(listaProcessos)
                .subscribe((rotinasProcesso: RotinaProcesso[]) => {
                    this.rotinasProcesso = rotinasProcesso;
                    this._rotinaService.obterRotinasClienteFromProcessosSetorHttp(listaProcessos)
                        .subscribe((rotinasCliente) => {
                            this.rotinasCliente = rotinasCliente;
                            this.rotinasCliente.forEach(rotina => {
                                this.rotinasSelectItem.push({ label: rotina.descricaoRotina, value: rotina.idRotinaCliente });
                            });
                            this.loading = false;
                        });
                });
        } else {
            this.loading = false;
        }
    }

    onSubmit(): void {
        this.loading = true;
        const self = this;
        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);
        if (self.agendaRoteiroPontoFisico.dataAgenda < hoje) {
            self.loading = false;
            self.confirmationService.confirm({
                message: 'N\u00e3o \u00e9 poss\u00edvel alterar uma agenda do passado.',
                rejectVisible: false,
                accept: () => {
                },
                reject: () => {
                }
            });
        } else {
            if (self.idsSetoresSelecionados.length > 0 && self.idsProcessosSelecionados.length > 0
                && self.idsRotinasSelecionados.length > 0) {
                self.manterAgendasRoteiroSetor();
            } else {
                self.loading = false;
                self.confirmationService.confirm({
                    message: '\u00c9 necess\u00e1rio selecionar ao menos um setor, processo e checklist',
                    rejectVisible: false,
                    accept: () => {
                    },
                    reject: () => {
                    }
                });
            }
        }
    }

    manterAgendasRoteiroSetor(): void {
        const agendasRoteiroSetorInsert = new Array<AgendaRoteiroSetor>();
        const agendasRoteiroSetorRemove = new Array<AgendaRoteiroSetor>();
        const setIdsSetores = new Set<number>();
        this.idsSetoresSelecionados.forEach(idSetor => {
            setIdsSetores.add(idSetor);
        });

        const setAgendasRoteiroSetor = new Set<number>();
        this.agendasRoteiroSetor.forEach(indicadorSetor => {
            setAgendasRoteiroSetor.add(indicadorSetor.idSetorPontoFisico);
        });

        this.setoresPontoFisico.forEach(setorPontoFisico => {
            if (setIdsSetores.has(setorPontoFisico.setor.idSetor)) {
                if (!setAgendasRoteiroSetor.has(setorPontoFisico.idSetorPontoFisico)) {
                    const agendaRoteiroSetor = new AgendaRoteiroSetor();
                    agendaRoteiroSetor.idAgendaRoteiroPontoFisico = this.agendaRoteiroPontoFisico.idAgendaRoteiroPontoFisico;
                    agendaRoteiroSetor.idSetorPontoFisico = setorPontoFisico.idSetorPontoFisico;
                    agendasRoteiroSetorInsert.push(agendaRoteiroSetor);
                }
            } else if (setAgendasRoteiroSetor.has(setorPontoFisico.idSetorPontoFisico)) {
                this.agendasRoteiroSetor.forEach(agendaRoteiroSetor => {
                    if (agendaRoteiroSetor.idSetorPontoFisico === setorPontoFisico.idSetorPontoFisico) {
                        agendasRoteiroSetorRemove.push(agendaRoteiroSetor);
                    }
                });
            }
        });

        if (agendasRoteiroSetorInsert.length > 0) {
            this._roteiroService.cadastrarAgendasRoteiroSetorHttp(agendasRoteiroSetorInsert)
                .subscribe(response => {
                    this.statusCode = response.status;
                }, errorCode => {
                    this.statusCode = errorCode;
                });
        }

        if (agendasRoteiroSetorRemove.length > 0) {
            this._roteiroService.removerAgendasRoteiroSetorHttp(agendasRoteiroSetorRemove)
                .subscribe(response => {
                    this.statusCode = response.status;
                }, errorCode => {
                    this.statusCode = errorCode;
                });
        }
        this.manterAgendasRoteiroProcesso();
    }

    manterAgendasRoteiroProcesso(): void {
        const agendasRoteiroProcessoInsert = new Array<AgendaRoteiroProcesso>();
        const agendasRoteiroProcessoRemove = new Array<AgendaRoteiroProcesso>();
        const setIdsProcessos = new Set<number>();
        this.idsProcessosSelecionados.forEach(idProcesso => {
            setIdsProcessos.add(idProcesso);
        });

        const setAgendasRoteiroProcesso = new Set<number>();
        this.agendasRoteiroProcesso.forEach(agendaRoteiroProcesso => {
            setAgendasRoteiroProcesso.add(agendaRoteiroProcesso.idProcessoSetor);
        });

        this.processosSetor.forEach(processoSetor => {
            if (setIdsProcessos.has(processoSetor.processo.idProcesso)) {
                if (!setAgendasRoteiroProcesso.has(processoSetor.idProcessoSetor)) {
                    const agendaRoteiroProcesso = new AgendaRoteiroProcesso();
                    agendaRoteiroProcesso.idAgendaRoteiroPontoFisico = this.agendaRoteiroPontoFisico.idAgendaRoteiroPontoFisico;
                    agendaRoteiroProcesso.idProcessoSetor = processoSetor.idProcessoSetor;
                    agendasRoteiroProcessoInsert.push(agendaRoteiroProcesso);
                }
            } else if (setAgendasRoteiroProcesso.has(processoSetor.idProcessoSetor)) {
                this.agendasRoteiroProcesso.forEach(agendaRoteiroProcesso => {
                    if (agendaRoteiroProcesso.idProcessoSetor === processoSetor.idProcessoSetor) {
                        agendasRoteiroProcessoRemove.push(agendaRoteiroProcesso);
                    }
                });
            }
        });

        if (agendasRoteiroProcessoInsert.length > 0) {
            this._roteiroService.cadastrarAgendasRoteiroProcessoHttp(agendasRoteiroProcessoInsert)
                .subscribe(response => {
                    this.statusCode = response.status;
                }, errorCode => {
                    this.statusCode = errorCode;
                });
        }

        if (agendasRoteiroProcessoRemove.length > 0) {
            this._roteiroService.removerAgendasRoteiroProcessoHttp(agendasRoteiroProcessoRemove)
                .subscribe(response => {
                    this.statusCode = response.status;
                }, errorCode => {
                    this.statusCode = errorCode;
                });
        }
        this.manterAgendasRoteiroRotina();
    }

    manterAgendasRoteiroRotina(): void {
        const agendqasRoteiroRotinaInsert = new Array<AgendaRoteiroRotina>();
        const agendasRoteiroRotinaRemove = new Array<AgendaRoteiroRotina>();
        const setIdsRotina = new Set<number>();
        this.idsRotinasSelecionados.forEach(idRotina => {
            setIdsRotina.add(idRotina);
        });

        const setAgendasRoteiroRotina = new Set<number>();
        this.agendasRoteiroRotina.forEach(agendaRoteiroRotina => {
            setAgendasRoteiroRotina.add(agendaRoteiroRotina.idRotinaProcesso);
        });

        this.rotinasProcesso.forEach(rotinaProcesso => {
            if (setIdsRotina.has(rotinaProcesso.rotinaCliente.idRotinaCliente)) {
                if (!setAgendasRoteiroRotina.has(rotinaProcesso.idRotinaProcesso)) {
                    const agendaRoteiroRotina = new AgendaRoteiroRotina();
                    agendaRoteiroRotina.idAgendaRoteiroPontoFisico = this.agendaRoteiroPontoFisico.idAgendaRoteiroPontoFisico;
                    agendaRoteiroRotina.idRotinaProcesso = rotinaProcesso.idRotinaProcesso;
                    agendqasRoteiroRotinaInsert.push(agendaRoteiroRotina);
                }
            } else if (setAgendasRoteiroRotina.has(rotinaProcesso.idRotinaProcesso)) {
                this.agendasRoteiroRotina.forEach(agendaRoteiroRotina => {
                    if (agendaRoteiroRotina.idRotinaProcesso === rotinaProcesso.idRotinaProcesso) {
                        agendasRoteiroRotinaRemove.push(agendaRoteiroRotina);
                    }
                });
            }
        });

        if (agendqasRoteiroRotinaInsert.length > 0) {
            this._roteiroService.cadastrarAgendasRoteiroRotinaHttp(agendqasRoteiroRotinaInsert)
                .subscribe(response => {
                    this.statusCode = response.status;
                }, errorCode => {
                    this.statusCode = errorCode;
                });
        }

        if (agendasRoteiroRotinaRemove.length > 0) {
            this._roteiroService.removerAgendasRoteiroRotinaHttp(agendasRoteiroRotinaRemove)
                .subscribe(response => {
                    this.statusCode = response.status;
                }, errorCode => {
                    this.statusCode = errorCode;
                });
        }
        this.agendaRoteiroPontoFisicoEvent.emit(this.agendaRoteiroPontoFisico);
        this.loading = false;
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/roteiro/cadastro-roteiro-interno/cadastro-roteiro-interno.component.ts